<script lang="ts">

import Timeline from "./timeline/Timeline.svelte";
import Main from "../main/Main.svelte";
import SourceEditor from "./SourceEditor.svelte";
import PlaybackControl from "./preview/PlaybackControl.svelte";


function getControlTarget() {
    return  document.getElementById('main-video') as HTMLVideoElement;
}

</script>

<div id="editor">
    <div id="editor-upperpart">
        <SourceEditor />
        <div id="editor-preview">
            <Main maxWidth="60%" maxHeight="calc(100% - 300px - 1rem)" />
            <PlaybackControl getControlTarget={getControlTarget}/>
        </div>
    </div>
    <div style="position:fixed;z-index:10000;bottom:300px;height:2px;left:0;right:0;user-select:none;background-color:#8f8f8f;" />
    <div style="position:fixed;z-index:10000;bottom:300px;height:calc(100% - 300px);left:40%;right:40%;width:2px;user-select:none;background-color:#8f8f8f;" />
    <Timeline />
</div>


<style>
    #editor-upperpart {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 300px;
        background-color: darkgray;
    }
    #editor-preview {
        position: fixed;
        top: 0;
        left: 40%;
        bottom: 300px;
        right: 0;
        width: 60%;
        background-color: black;
    }
</style>

